import React from 'react';
import clone from 'clone';

import classNames from 'classnames';

class LinearCheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showItem: 3,
      collapse: false,
    };
    this.handleChecked = this.handleChecked.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
  }
  componentWillMount() {

  }
  handleLoad(type, e) {
    e.preventDefault();
    this.setState({ collapse: !this.state.collapse });
    // this.props.onHandleShowMore(type);
  }
  handleChecked(e) {
    const values = [];
    this.options.forEach((item) => {
      if (item.key === parseInt(e.target.value, 10)) {
        item.isChecked = e.target.checked;
      }
      if (item.isChecked) values.push(item);
    });
    this.props.onSelectCheckBox(values);
  }
  render() {
    this.options = clone(this.props.options);
    this.options.map((item) => {
      if (this.props.value.indexOf(item.slug) !== -1) {
        item.isChecked = true;
      }
      this.props.previewData.map((filterItem) => {
        for (const key in filterItem.terms) {
          if (key === this.props.searchItem) {
            if (filterItem.terms[key].indexOf(item.slug) !== -1) {
              item.isEnabled = 'enabled';
            }
          }
        }
      });
      if (!item.isEnabled) {
        item.isEnabled = 'disabled';
      }
    });
    //  disabled={item.isEnabled === 'enabled' ? '' : 'disabled'}
    const singleCheckBoxItem = (item, index) => {

      return (
        <span className="single-input searchoption" key={'liCheckbox-' + index}>
          <input type="checkbox" id={item.slug + '-' + this.props.block.uid} checked={item.isChecked} value={item.key} onChange={this.handleChecked}/>
          <label className="" htmlFor={item.slug + '-' + this.props.block.uid}><span className="rq-search-text">{item.value}</span>
          {this.props.showNumberOfItems === 'true' ? <span className="pull-right rq-number-of-product" >{ item.count }</span> : ''}
          </label>
        </span>
      );
    };

    const childInputClass = classNames('input-container', this.props.isOpenElement);
    let setColumnStyle = null;
    if (this.props.setColumn === '1') {
      setColumnStyle = 'checkbox-input-content';
    } else if (this.props.setColumn === '2') {
      setColumnStyle = 'checkbox-input-content split';
    } else if (this.props.setColumn === '3') {
      setColumnStyle = 'checkbox-input-content split-2';
    } else if (this.props.setColumn === '4') {
      setColumnStyle = 'checkbox-input-content split-3';
    }
    const firstRowOptions = [];
    const remainingRowOptions = [];
    let showItem = this.props.showItem;
    for (let key = 0; key < showItem; key++) {
      if (key < parseInt(this.props.setColumn, 10)) {
        firstRowOptions.push(this.options[key]);
      } else if (this.state.collapse === true) {
        remainingRowOptions.push(this.options[key]);
      }
    }
    return (
      <div className={childInputClass}>
        <div className="flex-row rq-linear-search-container">
          <div className="flex-xs-11 flex-md-3">
            <span className="linearcheckboxtitle">{this.props.title}</span>
          </div>
          <div className="flex-md-8 flex-xs-12">
            <span className={setColumnStyle}>
              {firstRowOptions.length !== 0 && this.state.collapse === true ? <div className="linear-checkbox-firstrow"> {firstRowOptions.map(singleCheckBoxItem)} </div> : <div>{firstRowOptions.map(singleCheckBoxItem)}</div> }
              {remainingRowOptions.length !== 0 ? remainingRowOptions.map(singleCheckBoxItem) : null}
            </span>
          </div>
          <div className="flex-xs-1 flex-md-1">
           <a className="show-less-btn" href="#" onClick={this.handleLoad.bind(this, 'more')}>{this.state.collapse === false ? <i className="fa fa-chevron-down"></i> : <i className="fa fa-chevron-up"></i> }</a>
          </div>
        </div>
      </div>
    );
  }
}

LinearCheckBox.propTypes = {
  'previewData': React.PropTypes.array,
  'searchItem': React.PropTypes.string,
  'value': React.PropTypes.array,
  'options': React.PropTypes.array,
  'onSelectCheckBox': React.PropTypes.func,
  'isOpenElement': React.PropTypes.string,
  'showNumberOfItems': React.PropTypes.string,
  'setColumn': React.PropTypes.string,
  'block': React.PropTypes.object,
};

export default LinearCheckBox;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/element/linearcheckbox.js
 **/